module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nick Payne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Nick Payne ")]), _vm._v("is the author of the plays "), _c('I', [_vm._v("Wanderlust")]), _vm._v(", a new version of Sophocles' "), _c('I', [_vm._v("Electra")]), _vm._v(","), _c('I', [_vm._v(" One Day When We Were Young")]), _vm._v(", "), _c('I', [_vm._v("Constellations")]), _vm._v(", and "), _c('I', [_vm._v("Lay Down Your Cross")]), _vm._v(". He is the winner of the 2009 George Devine Award for Most Promising Playwright and the 2012 Harold Pinter Playwright's Award. He is currently under commission with the Royal Court Theatre, the Donmare Warehouse, and the Manhattan Theatre Club. He was born in 1984.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vb3gkN/tc-custom/9781466840737.jpg?1732052125071",
      "alt": "This image is the cover for the book If There Is I Haven't Found It Yet"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("If There Is I Haven't Found It Yet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" Fifteen-year-old Anna is bullied by her classmates for being overweight. Her mother, Fiona, decides to transfer her to the school where she teaches, but that only makes things worse. Anna's father, George, is no help—he's too obsessed with saving the world. Just as Anna gets suspended for head-butting one of her tormenters, her uncle Terry arrives for an unannounced visit. A heartbroken, filthy-mouthed slacker, Terry reaches out to Anna in a way that no one ever has. Their unexpected friendship sends her parents' rocky marriage into a tailspin as the whole family wonders what—or who—really needs saving."), _c('br'), _c('br'), _vm._v(" Nick Payne's "), _c('i', [_vm._v("If There Is I Haven't Found It Yet")]), _vm._v(" is a brilliantly sad, humorous, and empathetic play about a family stuck somewhere between knowing what the problem is and doing something about it. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0